/*
 * Copyright (C) 2026 SimpliCity Digital Inc - All Rights Reserved
 */

import { IntegrationManager } from "@simplicitycms/simplicity-integration";
import { DnvTupWidget } from "dnv-search-lib";
import { DnvBLSearchWidget } from "dnv-search-lib";
import { DnvPermitSearchWidget } from "dnv-search-lib";
import { DnvPlanningSearchWidget } from "dnv-search-lib";
import { DnvPropertyTaxCalculatorWidget } from "dnv-search-lib";
import { DnvReportAProblemWrapper } from "dnv-search-lib";
import { DNVCouncilPolicies } from "dnv-search-lib";
import { DNVElection } from "dnv-search-lib";
import { DNVCouncilDecisions } from "dnv-search-lib";
import { WebCouncilSearchWidget } from "dnv-search-lib";
import { DnvSubscribeCouncilNotices } from "dnv-search-lib";
import { DnvSubscribeDevelopmentNotices } from "dnv-search-lib";
import { DnvCorporatePlan } from "dnv-search-lib";
import { DnvMapSearch } from "components/development-applications/map-search";
import { DnvDevAppDetails } from "components/development-applications/devapp-details";

// Ideally integrations are registered with the prefix "integration."
// manager.addIntegration("integration.sample-id", IntegrationSample, "Integration Sample");

export const initializeIntegrationManager = () => {

    const manager = new IntegrationManager();

    // Register Custom Integrations
    manager.addIntegration("DnvTupWidget", DnvTupWidget, "Temporary Use Permits");
    manager.addIntegration("DnvBLSearchWidget", DnvBLSearchWidget, "Business Licence Search");
    manager.addIntegration("DnvPermitSearchWidget", DnvPermitSearchWidget, "Permits Search");
    manager.addIntegration("DnvPlanningSearchWidget", DnvPlanningSearchWidget, "Planning Search");
    manager.addIntegration("DnvPropertyTaxCalculatorWidget", DnvPropertyTaxCalculatorWidget, "Property Tax Calculator");
    manager.addIntegration("DnvReportAProblemWrapper", DnvReportAProblemWrapper, "Report A Problem");
    manager.addIntegration("WebCouncilSearchWidget", WebCouncilSearchWidget, "Council Search");
    manager.addIntegration("DNVCouncilPolicies", DNVCouncilPolicies, "Council Policies");
    manager.addIntegration("DNVElection", DNVElection, "Election");
    manager.addIntegration("DNVCouncilDecisions", DNVCouncilDecisions, "Council Decisions");
    manager.addIntegration("DnvSubscribeCouncilNotices", DnvSubscribeCouncilNotices, "Subscribe Council Notices");
    manager.addIntegration("DnvSubscribeDevelopmentNotices", DnvSubscribeDevelopmentNotices, "Subscribe Development Notices");
    manager.addIntegration("DnvCorporatePlan", DnvCorporatePlan, "Corporate Plan");
    manager.addIntegration("DnvMapSearch", DnvMapSearch, "Map Search");
    manager.addIntegration("DnvDevAppDetails", DnvDevAppDetails, "Development Application Details");

    // console.log("IntegrationManager started");
    return manager;
};
